const ButtonLoader = () => {
    return (
        <div className="loader"/>
    )
}

export default ButtonLoader
